import { useMemo } from 'react'

import { ThenPlace } from 'components/block/Then/Then.constants'
import { thenPartPath } from 'components/block/Then/Then.paths'
import { ratingPath } from 'components/page/RatingWave/Rating.paths'
import { redirectAfterAuthPath } from 'components/paths'
import {
  giftPresentPath,
  storeFrontGiftsPath,
  storeFrontUserPath,
} from 'components/storefront/StoreFront.paths'
import { removeLocale } from 'components/system/system.functions'
import { mergeAllUrls } from 'functions/mergeAllUrls'
import { useAuthorizationPath } from 'hooks/useAuthorizationLink'
import { useLayoutContext } from 'hooks/useLayoutContext'
import { useShallowEqualSelector } from 'hooks/useShallowEqualSelector'

/**
 * TODO: объединить в один файл с src/common/components/block/ControlButtonsBar/hooks/useChatUrl.ts
 * и перенести в ControlButtonsBar/hooks/
 * @param profileId
 * @returns
 *
 */
export const useStoreFrontGiftsUrl = (profileId: number) => {
  const { baseUrl } = useLayoutContext()
  const authorizationPath = useAuthorizationPath()

  const { authorized, locale } = useShallowEqualSelector(
    ({ authorizationReducer: { authorized }, systemReducer: { locale } }) => ({
      authorized,
      locale,
    })
  )

  const isRatingPath = baseUrl.includes(ratingPath)

  return useMemo(() => {
    if (authorized) {
      return mergeAllUrls(
        baseUrl,
        storeFrontGiftsPath,
        storeFrontUserPath,
        profileId,
        giftPresentPath
      )
    }

    if (isRatingPath) {
      return authorizationPath
    }

    return mergeAllUrls(
      locale,
      redirectAfterAuthPath,
      removeLocale(baseUrl),
      thenPartPath,
      ThenPlace.gift
    )
  }, [authorizationPath, authorized, baseUrl, isRatingPath, locale, profileId])
}
